var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';
import { white50 } from '../../Styles/Colours';
import { CloseIcon } from '../Icons';
import { StyledDialogActions } from './StyledDialogActions';
import { StyledDialogAppBar } from './StyledDialogAppBar';
import { StyledDialogContent } from './StyledDialogContent';
import { StyledDialogCore } from './StyledDialogCore';
import { Button } from '../Button';
var StyledDialog = /** @class */ (function (_super) {
    __extends(StyledDialog, _super);
    function StyledDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StyledDialog.prototype.render = function () {
        var _a = this.props, title = _a.title, titleBarRight = _a.titleBarRight, titleBarLeft = _a.titleBarLeft, headerExtraContents = _a.headerExtraContents, contentHeight = _a.contentHeight, children = _a.children, actions = _a.actions, sidebarRender = _a.sidebarRender, alertContent = _a.alertContent, titleComponent = _a.titleComponent, actionsComponent = _a.actionsComponent, contentComponent = _a.contentComponent, closeFunction = _a.closeFunction, isSubmitting = _a.isSubmitting, tighterActionButtons = _a.tighterActionButtons, otherProps = __rest(_a, ["title", "titleBarRight", "titleBarLeft", "headerExtraContents", "contentHeight", "children", "actions", "sidebarRender", "alertContent", "titleComponent", "actionsComponent", "contentComponent", "closeFunction", "isSubmitting", "tighterActionButtons"]);
        var finalTitleComponent = this.props.closeFunction ? (React.createElement(StyledDialogAppBar, { title: title, titleBarRight: React.createElement(Tooltip, { title: 'Close' },
                React.createElement(Button, { iconOnly: true, onClick: this.props.closeFunction, disabled: isSubmitting, testId: "dialog-control-close", noShadowOnHover: true, subtleShadeOnHover: true },
                    React.createElement(CloseIcon, { color: white50 }))), titleBarLeft: titleBarLeft, headerExtraContents: headerExtraContents })) : (titleComponent || (React.createElement(StyledDialogAppBar, { title: title, titleBarRight: titleBarRight, titleBarLeft: titleBarLeft, headerExtraContents: headerExtraContents })));
        var finalContentComponent = contentComponent || (React.createElement(StyledDialogContent, { contentHeight: contentHeight, backgroundClass: this.props.backgroundClass }, children));
        var finalActionsComponent = actionsComponent || (React.createElement(StyledDialogActions, { tighter: tighterActionButtons }, actions));
        return (React.createElement(StyledDialogCore, __assign({}, otherProps, { testId: this.props.testId, sidebarRender: sidebarRender, titleComponent: finalTitleComponent, contentComponent: finalContentComponent, actionsComponent: finalActionsComponent, alertContent: alertContent })));
    };
    StyledDialog.muiName = 'Dialog';
    return StyledDialog;
}(React.Component));
export { StyledDialog };
